import type { DeviceProfileRouteParams } from "@/components/navigate"
import type { Href } from "expo-router"

import { AppIcons } from "@/theme"
import i18n from "@/translations/i18n"

import type { IconProp } from "@/theme"

const PAGES = [
  {
    IconComponent: AppIcons.Timeline,
    href: "",
    id: "deviceProfileLanding",
    name: i18n.t("deviceProfile:linkToLanding"),
  },
  {
    IconComponent: AppIcons.DeviceConfiguration,
    href: "configuration",
    id: "deviceConfiguration",
    name: i18n.t("deviceProfile:linkToConfiguration"),
  },
  {
    IconComponent: AppIcons.NotificationsOn,
    href: "notification-rules",
    id: "deviceNotificationRules",
    name: i18n.t("deviceProfile:linkToNotifications"),
  },
  {
    IconComponent: AppIcons.DeviceCommandsRemote,
    href: "action-history",
    id: "deviceActionHistory",
    name: i18n.t("deviceProfile:linkToActionHistory"),
  },
  {
    IconComponent: AppIcons.History,
    href: "event-history",
    id: "deviceEventHistory",
    name: i18n.t("deviceProfile:linkToEventHistory"),
  },
  {
    IconComponent: AppIcons.Timeline,
    href: "analytics",
    id: "deviceAnalytics",
    name: i18n.t("deviceAnalytics:title"),
  },
] as const
export type DeviceProfilePageId = (typeof PAGES)[number]["id"]

interface PageConfig {
  IconComponent: IconProp
  href: Href
  id: DeviceProfilePageId
  name: string
}

export function getDeviceProfileBasePages(
  params: DeviceProfileRouteParams,
): PageConfig[] {
  return PAGES.map((page) => {
    const pathname = `/devices/[codaDeviceAlias]/${page.href}`
    const href = {
      params,
      pathname,
    } as Href
    return { ...page, href }
  })
}
